"use client";

import {JSX, useRef} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {ButtonBase} from "@/shared/ui/buttons/button-base";
import {Spinner} from "@/shared/ui/feedback/spinner";
import {assetPath} from "@/shared/utils/asset-path";
import {scrollToPromise} from "@/shared/utils/scroll";

import {RentalOffer, type RentalOfferProps} from "../rental-offer";

export interface RentalOfferShowMoreProps extends RentalOfferProps {
    showButton: boolean;
    isPaginationLoading: boolean;
    showReadLessButton?: boolean;
    onLoadMore: () => void;
    onShowLess: () => void;
}

export function RentalOfferShowMore({
    showButton,
    isPaginationLoading,
    showReadLessButton,
    onLoadMore,
    onShowLess,
    loading,
    ...rest
}: RentalOfferShowMoreProps): JSX.Element {
    const {t} = useTranslation("common");
    const sectionRef = useRef<HTMLElement>(null);

    const handleShowLess = async (): Promise<void> => {
        if (sectionRef.current) {
            const offset = 120;
            const y = sectionRef.current.getBoundingClientRect().top + window.scrollY - offset;
            await scrollToPromise(y, {behavior: "smooth"});
        }
        onShowLess();
    };

    return (
        <RentalOffer ref={sectionRef} loading={loading} {...rest}>
            {(showButton || isPaginationLoading) && !loading.isFiltering && (
                <div className="destination__button-wrap">
                    <ButtonBase variant="secondary-outline" size="xs-s" width="fit" onClick={onLoadMore}>
                        {isPaginationLoading ? (
                            <Spinner size="small" />
                        ) : (
                            <>
                                {t("showMore")}
                                <SmartImage src={assetPath("/images/icons/arrow-black-down.svg")} alt="Arrow" width={12} height={10} />
                            </>
                        )}
                    </ButtonBase>
                </div>
            )}
            {showReadLessButton && !loading.isFiltering && !isPaginationLoading && (
                <div className="destination__button-wrap">
                    <ButtonBase variant="secondary-outline" size="xs-s" width="fit" onClick={() => void handleShowLess()}>
                        {t("showLess")}
                        <SmartImage
                            src={assetPath("/images/icons/arrow-black-down.svg")}
                            alt="Arrow"
                            width={12}
                            height={10}
                            className="our-property__arrow our-property__arrow--up"
                        />
                    </ButtonBase>
                </div>
            )}
        </RentalOffer>
    );
}
